export enum ErrorsAuthorization {
	CAN_SCHEDULE,
	NO_NEED_AUTHORIZATION,
	NEED_AUTHORIZATION,
	UNAVAILABLE_SLOTS,
	MINIMUM_INTERVAL,
}
